document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-contact]');
    if (!root) return;

    const form = root.querySelector('[data-contact-form]');
    if (!form) return;

    const isLoggedIn = root.dataset.loggedIn === 'true';
    const statusEl = form.querySelector('[data-contact-status]');
    const submitBtn = form.querySelector('[data-contact-submit]');
    const loginPopup = document.getElementById('loginRequiredPopupOverlay');

    const requiredFields = Array.from(form.querySelectorAll('[data-required]'));
    const fieldByName = (name) => form.querySelector(`[data-contact-field="${name}"]`);

    // ----- Custom select init (country, gender, program) -----
    const customSelects = root.querySelectorAll('.contact__custom-select');
    customSelects.forEach((select) => bindCustomSelect(select));

    document.addEventListener('click', () => {
        customSelects.forEach((s) => s.classList.remove('open'));
    });

    function bindCustomSelect(select) {
        const trigger = select.querySelector('.contact__select-trigger');
        if (!trigger) return;
        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            customSelects.forEach((other) => {
                if (other !== select) other.classList.remove('open');
            });
            select.classList.toggle('open');
        });
        select.addEventListener('click', (e) => {
            const option = e.target.closest('.contact__option');
            if (!option || option.classList.contains('contact__option--disabled')) return;
            e.stopPropagation();
            const value = option.getAttribute('data-value') || '';
            const label = option.textContent.trim();
            const span = trigger.querySelector('span');
            const hidden = select.querySelector('input[type="hidden"]');
            if (span) span.textContent = label;
            if (hidden) {
                hidden.value = value;
                clearInvalid(hidden);
            }
            select.querySelectorAll('.contact__option').forEach((o) => o.classList.remove('selected'));
            option.classList.add('selected');
            select.classList.remove('open');
        });
    }

    // ----- Programs fetch (populate dropdown on page load) -----
    const programSelect = root.querySelector('[data-contact-program-select]');
    const programOptions = root.querySelector('[data-contact-program-options]');
    const programLabel = root.querySelector('[data-contact-program-label]');
    const programHidden = fieldByName('program');

    loadPrograms();

    async function loadPrograms() {
        try {
            const res = await fetch('/api/program/list', { headers: { Accept: 'application/json' } });
            const body = await res.json().catch(() => ({}));
            const programs = (body && body.success && body.data && Array.isArray(body.data.programs))
                ? body.data.programs
                : [];

            if (!programs.length) {
                renderProgramOptions([], 'No programs available');
                return;
            }
            renderProgramOptions(programs, 'Select Program');
        } catch (err) {
            console.error('contact: failed to load programs', err);
            renderProgramOptions([], 'Unable to load programs');
        }
    }

    function renderProgramOptions(programs, placeholder) {
        if (!programOptions || !programLabel) return;
        programOptions.innerHTML = '';
        if (!programs.length) {
            const empty = document.createElement('div');
            empty.className = 'contact__option contact__option--disabled';
            empty.setAttribute('data-value', '');
            empty.textContent = placeholder;
            programOptions.appendChild(empty);
            programLabel.textContent = placeholder;
            return;
        }
        programs.forEach((p) => {
            const opt = document.createElement('div');
            opt.className = 'contact__option';
            opt.setAttribute('data-value', p.value);
            opt.textContent = p.label;
            programOptions.appendChild(opt);
        });
        programLabel.textContent = placeholder;
    }

    // ----- Validation helpers -----
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function isFieldValid(field) {
        const value = (field.value || '').trim();
        if (!value) return false;
        if (field.type === 'email') return EMAIL_RE.test(value);
        if (field.name === 'phone_number') return /^\d{6,15}$/.test(value);
        return true;
    }

    function markInvalid(field) {
        const group = field.closest('.contact__form-group');
        if (group) group.classList.add('contact__form-group--invalid');
        const select = field.closest('.contact__custom-select');
        if (select) select.classList.add('contact__custom-select--invalid');
        field.classList.add('contact__form-input--invalid');
    }

    function clearInvalid(field) {
        const group = field.closest('.contact__form-group');
        if (group) group.classList.remove('contact__form-group--invalid');
        const select = field.closest('.contact__custom-select');
        if (select) select.classList.remove('contact__custom-select--invalid');
        field.classList.remove('contact__form-input--invalid');
    }

    function validateAll() {
        let firstInvalid = null;
        requiredFields.forEach((field) => {
            if (isFieldValid(field)) {
                clearInvalid(field);
            } else {
                markInvalid(field);
                if (!firstInvalid) firstInvalid = field;
            }
        });
        return { ok: !firstInvalid, firstInvalid };
    }

    // Clear invalid state as user corrects a field
    requiredFields.forEach((field) => {
        const evt = field.tagName === 'INPUT' ? 'input' : 'change';
        field.addEventListener(evt, () => {
            if (isFieldValid(field)) clearInvalid(field);
        });
    });

    // ----- Input sanitisers (parity with old contactus.js) -----
    const firstNameEl = fieldByName('first_name');
    const lastNameEl = fieldByName('last_name');
    const phoneEl = fieldByName('phone_number');
    if (firstNameEl) firstNameEl.addEventListener('input', function () {
        this.value = this.value.replace(/[^a-zA-Z\s]/g, '');
    });
    if (lastNameEl) lastNameEl.addEventListener('input', function () {
        this.value = this.value.replace(/[^a-zA-Z\s]/g, '');
    });
    if (phoneEl) phoneEl.addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '').slice(0, 15);
    });

    // ----- Prevent Enter-key submit (old-app parity) -----
    form.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
            e.preventDefault();
        }
    });

    // ----- Login popup controls (reuse course-idv popup) -----
    const loginClose = document.getElementById('loginRequiredPopupClose');
    function showLoginPopup() {
        if (!loginPopup) return;
        loginPopup.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
    function hideLoginPopup() {
        if (!loginPopup) return;
        loginPopup.classList.remove('active');
        document.body.style.overflow = '';
    }
    if (loginClose) loginClose.addEventListener('click', hideLoginPopup);
    window.addEventListener('click', (e) => {
        if (e.target === loginPopup) hideLoginPopup();
    });

    // ----- Submission -----
    function setStatus(message, kind) {
        if (!statusEl) return;
        statusEl.textContent = message || '';
        statusEl.classList.remove('contact__form-status--error', 'contact__form-status--success');
        if (kind) statusEl.classList.add(`contact__form-status--${kind}`);
    }

    function setSubmitting(isSubmitting) {
        submitBtn.disabled = isSubmitting;
        submitBtn.classList.toggle('contact__form-submit--loading', isSubmitting);
    }

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        // 1. Validate mandatory fields first — red-border path
        const { ok, firstInvalid } = validateAll();
        if (!ok) {
            setStatus('Please fill the highlighted fields.', 'error');
            if (firstInvalid && typeof firstInvalid.focus === 'function') firstInvalid.focus();
            return;
        }

        // 2. Must be signed in — show existing login popup
        if (!isLoggedIn) {
            setStatus('You need to sign in before submitting.', 'error');
            showLoginPopup();
            return;
        }

        // 3. reCAPTCHA (v2 checkbox) must be completed
        let captchaToken = '';
        if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.getResponse === 'function') {
            captchaToken = grecaptcha.getResponse();
            if (!captchaToken) {
                setStatus('Please complete the reCAPTCHA verification.', 'error');
                return;
            }
        }

        // 4. Submit
        setStatus('Submitting your request…');
        setSubmitting(true);
        try {
            const payload = new FormData(form);
            if (captchaToken) payload.set('g-recaptcha-response', captchaToken);
            const res = await fetch('/api/contactus/lead', {
                method: 'POST',
                body: payload,
                headers: { Accept: 'application/json' },
            });
            const body = await res.json().catch(() => ({}));

            if (res.ok && body && body.Success) {
                // Take the student to the success page with their name + the
                // program they enquired about, so it shows a confirmation.
                const firstNameEl = form.querySelector('[name="first_name"]');
                const firstName = ((firstNameEl && firstNameEl.value) || '').trim();
                const courseName = ((programLabel && programLabel.textContent) || '').trim();
                const params = new URLSearchParams();
                if (firstName) params.set('name', firstName);
                if (courseName && !/^(select program|loading)/i.test(courseName)) {
                    params.set('program', courseName);
                }
                window.location.href = '/contact-success' + (params.toString() ? '?' + params.toString() : '');
                return;
            }

            const errMessage =
                (body && body.Error && body.Error.data && body.Error.data.message) ||
                body.message ||
                'Unable to submit the form. Please try again.';
            setStatus(errMessage, 'error');
        } catch (err) {
            console.error('contact: submit failed', err);
            setStatus('Network error. Please try again.', 'error');
        } finally {
            setSubmitting(false);
        }
    });
});
